__turbopack_context__.v({
  "root": "styles-module-scss-module__UN31OW__root",
});
